import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
} from "recharts";

const COLORS = [
  "#2F7F8F",
  "#F78C6B",
  "#B28AF8",
  "#FFB15C",
  "#7FB2FF",
  "#5EC1A6",
];

// extract "$180–260" from text
const parseSpendRange = (text) => {
  const match = text.match(/\$(\d+)[–-](\d+)/);
  if (!match) return { label: "$0-0", value: 0 };
  return {
    label: `$${match[1]}-${match[2]}`,
    value: (Number(match[1]) + Number(match[2])) / 2,
  };
};

// custom label like image (Day X $130-40)
const renderSpacedLabel = ({
  cx,
  cy,
  midAngle,
  outerRadius,
  index,
  payload,
}) => {
  const RADIAN = Math.PI / 180;

  // push labels further out
  const radius = outerRadius + 32;

  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  // vertical spacing adjustment
  const offsetY = midAngle > 90 && midAngle < 270 ? 10 : -10;

  return (
    <text
      x={x}
      y={y + offsetY}
      textAnchor={x > cx ? "start" : "end"}
      dominantBaseline="central"
      style={{
        fontSize: "12px",
        fill: "#444",
        lineHeight: "16px",
      }}
    >
      <tspan x={x} dy="-0.4em">
        {payload.name}
      </tspan>
      <tspan x={x} dy="1.2em" fontWeight="600">
        {payload.range}
      </tspan>
    </text>
  );
};


export default function SpendDonutChart({ days = [] }) {
  const data = days.map((day) => {
    const spend = parseSpendRange(day.estimatedSpend);
    return {
      name: `Day ${day.dayNumber}`,
      value: spend.value,
      range: spend.label,
    };
  });

  return (
    <ResponsiveContainer width="100%" height={380}>
      <PieChart>
        <Pie
          data={data}
          dataKey="value"
          cx="50%"
          cy="50%"
          innerRadius={90}
          outerRadius={130}
          paddingAngle={1}
          labelLine
          label={renderSpacedLabel}
        >

          {data.map((_, index) => (
            <Cell key={index} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
      </PieChart>
    </ResponsiveContainer>
  );
}
